
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({

    activeMovimientos: null,
    movimientos: [],
    isLoadingMovimientos: false,
    totalMovimientos: 0,




    // infoActiveMovimientos: async(info) => {
    //     set({ activeMovimientos: info });
    // },
    
});








export const useMovimientosStore = create()(
    devtools(
        storeApi
    )
)
